export const getAndroidAppSignature = () => undefined;

export default () => null;
